import { NgClass } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { I18nService } from '../../../../../core/services/i18n.service';

@Component({
  selector: 'db-no-data-info',
  imports: [
    NgClass
  ],
  templateUrl: './db-no-data-info.component.html',
})
export class DbNoDataInfoComponent {

  @Input() public message: string = '';
  @Input() public i18nMessageKey: string = null;
  @Input() small: boolean = false;

  i18n = inject(I18nService);

}
